// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavMenu-module--nav--1bLis"};